// One image is built with ZG_ENV=production (modules/docker/Dockerfile) and deployed
// to every environment, so a NEXT_PUBLIC_ twin of any environment variable bakes to
// 'production' everywhere. RootLayout emits the runtime ZG_ENV as a meta tag instead,
// which is the only way the browser can tell comet-1/Sherman from production.
export const ZG_ENV_META_NAME = 'zg-env';

/**
 * The runtime ZG_ENV, or '' when the tag is absent — during SSR, or on a response
 * that never rendered it. Callers pick their own fallback, because the safe default
 * differs: telemetry wants 'localhost', ad targeting wants production inventory.
 */
export function readZgEnvironment(): string {
  if (typeof document === 'undefined') return '';
  return document.querySelector<HTMLMetaElement>(`meta[name="${ZG_ENV_META_NAME}"]`)?.content ?? '';
}
